const dataSetEditProperty = 'data-edit-Mode';
/* WARNING ONLY NEEDED IN ADOBE EXPERIENCE MANAGER [AUTHOR]
  Check if we are in author mode or not.
  There this attribute defined on the 'dataSetEditProperty' variable
  that tell us if we are in AEM or not, unfortunately this attribute is not
  updated on the parent of X elements. What happens is that the attributes on
  a parent element are a sum of all its children attributes. What this means is
  that some attributes (like the one we need here) are not reactive. So we basically search
  for any children with the attribute set to true to check if we are in edit mode or not.
*/
export function isAemAuthorMode(): boolean {
  const elementChildren = document.querySelector(`owc-tab-item[${dataSetEditProperty}='true']`);

  return Boolean(elementChildren);
}
